import { Box, BoxProps, Typography, TypographyProps, Grid, GridProps, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Button from '../Button/Button';
import { ButtonProps } from '../Button/ButtonModels';

export const FooterContainer = styled(Box)<BoxProps>(({ theme }) => ({
  padding: '1.25rem 1.75rem',
  minHeight: '30vh',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  background: theme.palette.monochrome.monoChrome6,
  alignItems: 'center',
}));

export const GridContainer = styled(Grid)<GridProps>(() => ({
  '&.MuiGrid-root': {
    margin: 0,
    paddingRight: '1.5rem',
  },
}));

export const GridItem = styled(Grid)<GridProps>(({ theme }) => ({
  '&.MuiGrid-item': {
    padding: 0,
  },
  [theme.breakpoints.down('lg')]: {
    paddingTop: '0 !important',
  },
}));

export const LinksContainer = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  [theme.breakpoints.down('lg')]: {
    gap: '0.5rem',
  },
}));

export const FooterText = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: theme.palette.footer.link,
  fontSize: '0.875rem',
  lineHeight: 'normal',
}));

export const FooterLink = styled(Link)(({ theme }) => ({
  fontStyle: 'normal',
  textDecorationColor: theme.palette.text.primary,
  color: theme.palette.footer.link,
  fontSize: '1.125rem',
  lineHeight: '1.625rem',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
    textDecorationColor: theme.palette.footer.linkHover,
    color: theme.palette.footer.linkHover,
    transition: '0.4s',
  },
}));

export const FooterHeader = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: theme.palette.footer.link,
  fontSize: '1.25rem',
  fontWeight: 'bold',
  lineHeight: 'normal',
}));

export const FooterButton = styled(Button)<ButtonProps>(({ theme }) => ({
  padding: '0',
  backgroundColor: `${theme.palette.monochrome.monoChrome6} !important`,
  width: '100%',
  height: '2rem',
}));

export const FooterButtonText = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: theme.palette.footer.link,
  fontSize: '1.5rem',
  fontWeight: 'bold',
  lineHeight: 'normal',
}));

export const ButtonTextContainer = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  flex: 1,
}));

export const FooterDivider = styled(Divider)(() => ({
  margin: '0 0.5rem',
}));
